import api from "./api";

class BloqueioAPI {
  async getCfg(headers) {
    return api.get("/cfg/bloqueio", { headers });
  }

  async salvarCfg(headers, params) {
    return api({
      method: "post",
      url: "/cfg/bloqueio",
      headers,
      data: params,
    });
  }

  async buscarUsuarios(headers, busca) {
    return api.get("/cfg/bloqueio/usuarios", { headers, params: { busca } });
  }

  async liberar(headers, params) {
    return api({
      method: "post",
      url: "/cfg/bloqueio/liberar",
      headers,
      data: params,
    });
  }
}

export default new BloqueioAPI();
